// Typed reads for the `partner_logos` table.
import { supabase } from "@/integrations/supabase/client";

export interface PartnerLogo {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  logo_dark_url: string | null;
  website_url: string | null;
  display_order: number;
  active: boolean;
}

export async function listActivePartnerLogos(): Promise<PartnerLogo[]> {
  const { data, error } = await supabase
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .from("partner_logos" as any)
    .select(
      "id, name, slug, logo_url, logo_dark_url, website_url, display_order, active",
    )
    .eq("active", true)
    .order("display_order", { ascending: true });
  if (error) throw error;
  return (data ?? []) as unknown as PartnerLogo[];
}
